var styles = {"volumeDiscount":"ep-pricing-module-volume-discount-dm9sd"};

export { styles as default };
